// @flow
import React from 'react'
import Title from './Title'
import MetaData from './MetaData'

type Props = {
  model: Object,
}

export default class PRListItem extends React.Component<Props> {
  render () {
    const model = this.props.model
    const prUrl = model.get('pr_html_url')
    return <div style={{padding: '10px 0px', borderBottom: '1px solid #ebebeb'}}>
      <Title
        href={model.pullRequestPagePath()}
        prNumber={prUrl.substr(prUrl.lastIndexOf('/') + 1)}
        prTitle={model.get('pr_title')}
        author={(model.get('event_group') && model.get('event_group').author_email) || ''}
        timeAgo={model.get('event_group') && model.get('event_group').time_ago}
      />
      <MetaData
        prStatus={model.get('pr_status')}
        issuesDiff={model.get('issues_diff')}
      />
    </div>
  }
}

window.Components.PRListItem = React.createFactory(PRListItem)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/PRList/PRListItem/index.js